import { Box, IconButton, Input, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const RunNameComponent = (props: {
  name: string;
  setName: (name: string) => void;
  saveName: () => void;
  deleteName: () => void;
}) => {
  const { name, setName, saveName, deleteName } = props;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Input
        value={name}
        onChange={(event) => setName(event.target.value)}
        onBlur={() => saveName()}
        sx={{ flex: 1 }}
      />
      {name && (
        <Tooltip title="delete run name">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              deleteName();
            }}
            aria-label="delete run name"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
